"use client";

import { getOrCreateMatomoSessionId } from "@/utils/matomo-session";
import axios from "axios";

export function trackMatomoPageView() {
  axios.post("/api/matomo", {
    url: window?.location?.href,
    referrer: document.referrer,
    hostname: window?.location?.hostname,
    userAgent: navigator.userAgent,
    sessionId: getOrCreateMatomoSessionId(),
    title: document.title,
    screenWidth: window?.screen?.width,
    screenHeight: window?.screen?.height,
    viewportWidth: document?.documentElement?.clientWidth, // maybe useful
    viewportHeight: document?.documentElement?.clientHeight, // maybe useful
  } as MatomoPageViewOptions);
}

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { MatomoPageViewOptions } from "@/app/api/matomo/route";

export function useMatomoPageTracking() {
  const pathname = usePathname();
  useEffect(() => {
    trackMatomoPageView();
  }, [pathname]);
}
